import { Star } from "lucide-react";
import { TESTIMONIALS } from "@/data/content";
import { SectionHeading } from "./SectionHeading";

export const Testimonials = () => (
  <section id="reviews" className="border-t border-white/5 bg-black py-24">
    <div className="container mx-auto px-4 sm:px-6 lg:px-8">
      <SectionHeading
        kicker="Відгуки"
        title="Що кажуть клієнти"
        subtitle="Приклади відгуків клієнтів. Реальні рекомендації від людей, яким я підібрав автомобіль."
      />
      <div className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-2">
        {TESTIMONIALS.map((t, i) => (
          <figure
            key={i}
            data-testid={`testimonial-${i}`}
            className="flex flex-col rounded-md border border-white/10 bg-[#121212] p-8"
          >
            <div className="mb-4 flex gap-1 text-[#B12A2A]">
              {Array.from({ length: 5 }).map((_, s) => (
                <Star key={s} className="h-4 w-4 fill-current" />
              ))}
            </div>
            <blockquote className="flex-1 text-base leading-relaxed text-white/80">"{t.text}"</blockquote>
            <figcaption className="mt-6 flex items-center gap-4 border-t border-white/10 pt-5">
              <div className="flex h-11 w-11 items-center justify-center rounded-full bg-[#B12A2A] font-heading text-lg font-bold text-white">
                {t.name[0]}
              </div>
              <div>
                <div className="font-semibold text-white">{t.name}, <span className="text-white/50">{t.city}</span></div>
                <div className="text-sm text-[#B12A2A]">{t.car}</div>
              </div>
            </figcaption>
          </figure>
        ))}
      </div>
    </div>
  </section>
);
